/*************************************************/
/* ACCORDION                                     */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function accordion() {
    const accordionParentSelector = '.accordion';
    const accordionItemSelector = '.accordion__item';
    const accordionItemToggleSelector = '.accordion__item-head';
    const accordionItemContentSelector = '.accordion__item-content';
    const accordionItemActiveClass = 'accordion__item--active';
    const accordionIdDataAttributeName = 'data-accordion-id';
    const accordionItemIdDataAttributeName = 'data-accordion-item-id';
    const accordionImagesSelector = '.accordion-images';
    const accordionImagesContainerSelector = '.accordion-images__images-container';

    const getTargetedAccordion = (event) => {
        if (event != null) {
            return document.querySelector(
                `[${accordionIdDataAttributeName}="${event.detail.accordionId}"]`);
        }
    };
    const getTargetedAccordionItem = (event) => {
        if (event != null) {
            const targetedAccordion = getTargetedAccordion(event);
            if (targetedAccordion != null) {
                return targetedAccordion.querySelector(
                    `[${accordionItemIdDataAttributeName}="${event.detail.accordionItemId}"]`
                );
            }
        };
    }

    const setActiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            accordionItemContent.style.maxHeight = `${accordionItemContent.scrollHeight}px`;
            accordionItemContent.setAttribute('aria-hidden', false);
            accordionItem.classList.add(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', true);

            const customColor = accordionItem.dataset.accordionItemColor;
            if (customColor) {
                accordionItem.style.setProperty('background-color', customColor, 'important');
            }
        }
    };

    const setInactiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            accordionItemContent.style.maxHeight = "0px";
            accordionItemContent.setAttribute('aria-hidden', true);
            accordionItem.classList.remove(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', false);

            const customColor = accordionItem.dataset.accordionItemColor;
            if (customColor) {
                accordionItem.style.setProperty('background-color', customColor, 'important');
            }
        }
    };

    const init = () => {
        const accordions = document.querySelectorAll(accordionParentSelector);
        if (accordion != null && accordions.length > 0) {
            accordions.forEach(accordion => {
                accordion.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem) {
                        const deactivateAllItemsEvent = new CustomEvent(customEventsNames.accordionDeactivateAllItemsEventName, {
                            detail: {
                                accordionId: e.detail.accordionId
                            }
                        });
                        accordion.dispatchEvent(deactivateAllItemsEvent);
                    }

                    if (targetedAccordionItem != null) {
                        setActiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem != null) {
                        setInactiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateAllItemsEventName, e => {
                    const targetedAccordion = getTargetedAccordion(e);
                    if (targetedAccordion != null) {
                        targetedAccordion.querySelectorAll(accordionItemSelector).forEach(accordionItem => {
                            setInactiveStylesOnAccordionItem(accordionItem);
                        });
                    }
                });

                accordion.querySelectorAll(accordionItemToggleSelector).forEach(accordionItem => {
                    accordionItem.addEventListener('click', e => {
                        const clickedAccordionItem = e.target.closest(accordionItemSelector);
                        const itemId = clickedAccordionItem.dataset.accordionItemId;
                        const itemIndex = clickedAccordionItem.dataset.accordionItemIndex;
                        const accordionParent = e.target.closest(accordionParentSelector);
                        const accordionId = accordionParent.dataset.accordionId;

                        if (clickedAccordionItem.classList.contains(accordionItemActiveClass)) {
                            const deactiveAccordionItemEvent = new CustomEvent(customEventsNames.accordionDeactivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                }
                            });
                            accordionParent.dispatchEvent(deactiveAccordionItemEvent);
                        } else {
                            const activateAccordionItemEvent = new CustomEvent(customEventsNames.accordionActivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                    accordionItemIndex: itemIndex,
                                }
                            });
                            accordionParent.dispatchEvent(activateAccordionItemEvent);

                            const accordionImagesParent = accordionItem.closest(accordionImagesSelector);
                            if (accordionImagesParent) {
                                accordionImagesParent.querySelector(accordionImagesContainerSelector).dispatchEvent(activateAccordionItemEvent)
                            }
                        }
                    });
                });

                // Initially set the height of the first active item
                setActiveStylesOnAccordionItem(accordion.querySelector(`.${accordionItemActiveClass}`));

                const accordionInitialized = new CustomEvent(customEventsNames.accordionInitialised, {});
                accordion.dispatchEvent(accordionInitialized);

            });
        }
    };

    init();
}